import { useSuspenseQuery } from '@tanstack/react-query'
import { ChevronRightIcon } from 'lucide-react'
import { Suspense } from 'react'
import { useInRouterContext } from 'react-router'

import EmployerInvoicesPaths from 'rails_routes/Employers/EmployerInvoicesPaths'
import { ButtonLink } from 'slab'
import {
  getEmployersEmployerInvoicesLastMonthCosts,
  getGetEmployersEmployerInvoicesLastMonthCostsQueryKey,
} from 'utils/web_api'

import EmptyState from './EmptyState'
import { LastMonthCostItem } from './LastMonthCostItem'

function LastMonthCostComponent () {
  const { data } = useSuspenseQuery({
    queryKey: getGetEmployersEmployerInvoicesLastMonthCostsQueryKey(),
    queryFn: () => getEmployersEmployerInvoicesLastMonthCosts(),
  })

  const isInDashboardSPA = useInRouterContext()

  if (!data?.items?.length) {
    return <EmptyState />
  }

  return (
    <div className='flex flex-col gap-6'>
      <p className='body text-gray-500'>Last month's costs</p>
      <div className='flex flex-col gap-4'>
        {data.items.map((item) => (
          <LastMonthCostItem key={item.type} item={item} />
        ))}
      </div>
      <div className='flex justify-end -mr-4'>
        <ButtonLink
          href={isInDashboardSPA ? EmployerInvoicesPaths.index() : 'invoices'}
          rightIcon={ChevronRightIcon}
          variant='tertiary-deemphasized'
        >
          See all bills
        </ButtonLink>
      </div>
    </div>
  )
}

export function LastMonthCost () {
  const fallback = (
    <div className='flex flex-col gap-6'>
      <p className='body text-gray-500'>Last month's costs</p>
      <div className='animate-pulse space-y-2'>
        <div className='h-14 bg-gray-100 rounded' />
        <div className='h-14 bg-gray-100 rounded' />
      </div>
    </div>
  )

  return (
    <Suspense fallback={fallback}>
      <LastMonthCostComponent />
    </Suspense>
  )
}
